import axiosInstance from '../../Helpers/api_helper';

export const userLogin = async (
  email: string,
  password: string
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      'api/v1/participants/login',
      {
        email: email,
        password: password,
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error logging in user:', error.message);
    throw error;
  }
};